var $258a89609cea867c$exports = {};
$258a89609cea867c$exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};


export {$258a89609cea867c$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
